import React from 'react';
import { Icon } from '../core/Icon.jsx';

/** Membership benefit blurb: soft-orange glyph, display title, short desc. */
export function BenefitItem({ icon, title, desc, className = '', style }) {
  return (
    <div className={`bjl-benefit ${className}`} style={style}>
      <span className="bjl-benefit__glyph"><Icon name={icon} style={{ verticalAlign: 0 }} /></span>
      <span className="bjl-benefit__title">{title}</span>
      {desc ? <span className="bjl-benefit__desc">{desc}</span> : null}
    </div>
  );
}
